/**
 * Adds global close (click anywhere) for the given element
 *
 * @param elementId
 * @param element
 */
function addToGlobalClose(elementId, element) {
    document.addEventListener('click', (e) => {
        // Check if the filter list parent element exist
        const isClosest = e.target.closest(elementId);

        if (!element) return ;

        // If `isClosest` equals falsy & popup has the class `show`
        // then hide the menu
        if (element && !isClosest && element.classList.contains('show')) {
            element.classList.remove('show');
        }
    });
}

/**
 * initialize functionality for the sharing for given chart
 *
 * @param chartId
 */
function initShareMenu(chartId) {
    const shareMenuId = `ul#social-share-menu-${chartId}`;

    const shareMenuButtons =
        document.querySelectorAll('.chart-share-menu .menu .btn');

    shareMenuButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.stopPropagation();

            const targetId = button.dataset.target,
                targetElement = document.querySelector(targetId);

            if (!targetElement.classList.contains('show')) {
                let openedExportMenu = document.querySelector('.export-menu.show');
                let openedShareMenu = document.querySelector('.share-menu.show');

                if (openedExportMenu) {
                    openedExportMenu.classList.remove('show');
                }

                if (openedShareMenu) {
                    openedShareMenu.classList.remove('show');
                }

                targetElement.classList.add('show');
            }
        })
    });

    const shareMenu = document.querySelector(shareMenuId),
        modal = document.querySelector('#lightbox-' + chartId);

    const iframeButton = document.querySelector(`ul#social-share-menu-${chartId} .share-iframe`),
        modalCloseButton = document.querySelector(`#lightbox-${chartId} .modal__close`);

    if (iframeButton) {
        iframeButton.addEventListener('click', function (e) {
            modal.setAttribute('open', 'open');
        });
    } else {
        console.error('No iframe button for', chartId);
    }

    if (modalCloseButton) {
        modalCloseButton.addEventListener('click', function (e) {
            modal.removeAttribute('open');
        });
    } else {
        console.error('No modalClose button for', chartId);
    }


    addToGlobalClose(shareMenuId, shareMenu);
}

/**
 * initialize Export Menu for given chart
 *
 * @param chartId
 * @param chart
 * @param filename
 */
function initExportMenu(chartId, chart, filename) {
    const exportMenuId = `ul#export-menu-${chartId}`;

    const exportMenu = document.querySelector(exportMenuId);

    const pngButton = document.querySelector(`ul#export-menu-${chartId} .png`),
        svgButton = document.querySelector(`ul#export-menu-${chartId} .svg`),
        jpgButton = document.querySelector(`ul#export-menu-${chartId} .jpg`);

    pngButton.addEventListener('click', function (e) {
        e.preventDefault();
        chart.exportChartLocal({
            filename: filename
        });
    });

    jpgButton.addEventListener('click', function (e) {
        e.preventDefault();

        chart.exportChartLocal({
            type: 'image/jpg',
            filename: filename
        })
    });

    svgButton.addEventListener('click', function (e) {
        e.preventDefault();

        chart.exportChartLocal({
            type: 'image/svg+xml',
            filename: filename
        })
    });

    addToGlobalClose(exportMenuId, exportMenu)
}


/**
 * expose initialize function
 *
 * Set chart to null if there is no export (tables)
 *
 * @param chartId
 * @param chart
 * @param filename
 * @param fullId full id with language for cases where neccesary
 */
export default (chartId, chart, filename, fullId) => {
    initShareMenu(chartId);

    if (chart) {
        initExportMenu(chartId, chart, filename)
    } else {
        initExportTable(chartId, fullId);
    }
}

/**
 * initialize Export Menu for given table
 *
 * @param chartId
 * @param filename
 */
function initExportTable(chartId, fullId) {
   
    const exportMenuId = `ul#export-menu-${chartId}`;
    const exportMenu = document.querySelector(exportMenuId);
    const csvButton = document.querySelector(`ul#export-menu-${chartId} .csv`);

    let tableId = fullId ? fullId : chartId;
    const table = document.querySelector(`table[id^="${tableId}"]`);

    if (csvButton) {
        csvButton.addEventListener('click', function (e) {
            e.preventDefault();

            var filename = table.id;
            var tableCsvData = getTableDataCsvFormat(table);

            if (tableCsvData) {
                downloadCSVFile(tableCsvData, filename);
            }
        });
    }

    addToGlobalClose(exportMenuId, exportMenu)
}

function getTableDataCsvFormat (table) {
    var csvData = [];
    var tableRows = table.querySelectorAll('tr:not(.hidden)');
    var regex = /(<([^>]+)>)/ig;

    for (var i = 0, len = tableRows.length; i < len; i++) {
        var tableColumns = tableRows[i].querySelectorAll('td:not(.hidden,.csv-exclude),th:not(.hidden,.csv-exclude)');
        var csvRow = [];

        for (var j = 0, leng = tableColumns.length; j < leng; j++) {
            var cellText =  `"${tableColumns[j].innerHTML.replace(regex, ' ').trim()}"`;
            cellText = cellText.replace('&amp;', '&');
            csvRow.push(cellText);
        }

        csvData.push(csvRow.join(','));
    }

    csvData = csvData.join('\n');

    return csvData;
}

function downloadCSVFile(csvData, filename) {
    var BOM = new Uint8Array([0xEF,0xBB,0xBF]);

    // eslint-disable-next-line no-undef
    var CSVFile = new Blob([BOM, csvData],
        {
            encoding: 'UTF-8',
            type: 'text/plain;charset=UTF-8'
        }
    );

    var tempLink = document.createElement('a');
    tempLink.download = filename + '.csv';

    var url = window.URL.createObjectURL(CSVFile);
    tempLink.href = url;

    tempLink.style.display = 'none';
    document.body.appendChild(tempLink);

    tempLink.click();
    document.body.removeChild(tempLink);
}